import { classNames } from 'primereact/utils';
import { PrimeReactStylesFunctionType } from '../types';

export const TreeTailwindThemes = {
  tree: {
    root: {
      className: classNames('min-w-fit w-full', 'bg-fletchers-gray-50', 'text-gray-700'),
    },
    wrapper: 'overflow-auto',
    container: 'm-0 p-0 list-none overflow-auto',
    node: classNames(
      'relative group',
      'pl-0 pr-0 outline-none',
      'rounded-none transition-shadow duration-200',
      '[&>ul>li]:before:absolute [&>ul>li]:before:-left-px [&>ul>li]:before:h-full',
      '[&>ul>li]:before:border-l-1 [&>ul>li]:before:border-fletchers-gray-100 [&>ul>li]:before:z-1',
      '[&>ul>li]:before:pointer-events-none [&>ul>li]:last:before:border-transparent',
    ),
    content: ({ context, props }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'relative flex items-center',
        'rounded-none transition-shadow duration-200 p-2.5 pl-6',
        'focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:shadow-none group-focus-visible:after:bg-gray-200',
        'after:absolute after:right-0 after:w-(--tree-component-width) after:h-full hover:after:bg-fletchers-green-50',
        {
          'after:bg-fletchers-green-100 hover:after:bg-fletchers-green-100': context.selected,
        },
        { 'cursor-pointer select-none': props.selectionMode == 'single' || props.selectionMode == 'multiple' },
      ),
    }),
    toggler: ({ context }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'order-3 ml-auto cursor-pointer select-none inline-flex items-center justify-center overflow-hidden relative shrink-0',
        'z-1 mr-2 w-8 h-8 border-0 bg-transparent rounded-full transition duration-200',
        'text-fletchers-green-500 hover:bg-gray-200',
        {
          hidden: context.leaf,
        },
      ),
    }),
    togglericon: ({ context }: PrimeReactStylesFunctionType) => (context.expanded ? 'rotate-180' : 'rotate-90'),
    label: 'order-2',
    checkboxcontainer: 'mr-2',
    checkbox: ({ context, props }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'cursor-pointer inline-flex relative select-none align-bottom',
        'w-6 h-6',
        'flex items-center justify-center',
        'border-2 w-6 h-6 rounded-lg transition-colors duration-200 text-white text-base',
        {
          'border-gray-300 bg-white': !context.checked,
          'border-fletchers-gray-200 text-white bg-fletchers-gray-200': context.checked,
        },
        {
          'hover:border-fletchers-gray-200 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]':
            !props.disabled,
          'cursor-default opacity-60': props.disabled,
        },
      ),
    }),
    nodeicon: 'order-1 mr-2 text-gray-600',
    subgroup: {
      className: classNames(
        'm-0 p-0 pl-6 list-none',
        '[&>li>[data-pc-section="content"]]:before:absolute [&>li>[data-pc-section="content"]]:before:top-0',
        '[&>li>[data-pc-section="content"]]:before:bottom-1/2 [&>li>[data-pc-section="content"]]:before:-left-px',
        '[&>li>[data-pc-section="content"]]:before:w-4 [&>li>[data-pc-section="content"]]:before:border-b-1',
        '[&>li>[data-pc-section="content"]]:before:border-l-1 [&>li>[data-pc-section="content"]]:before:border-fletchers-gray-100',
        '[&>li>[data-pc-section="content"]]:before:rounded-bl-sm [&>li>[data-pc-section="content"]]:before:z-1',
      ),
    },
    filtercontainer: {
      className: classNames('mb-2', 'relative block w-full'),
    },
    input: {
      className: classNames(
        'm-0 p-3 text-base w-full pr-7',
        'font-sans text-gray-600',
        'bg-white',
        'border border-gray-300',
        'transition-colors duration-200 appearance-none rounded-lg',
        'hover:border-fletchers-gray-200 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]',
      ),
    },
    searchicon: 'absolute top-1/2 -mt-2 right-3 text-gray-600',
  },
};
